module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAD5AAAA+QEdhgSBAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAG9QTFRF////VVWqQECASUmSQGCfRl2iN1ukO1idPFWgOVWhPFSfO1WeOlWfOlWeO1SeO1WfOlaeO1afOlSfOlafOVSeOlWgOlWfOVWfOVWfOlWfO1WfOlWfOlWgOlWfOlWfO1WfOlWfOlWfOlWgOlWfOlWfKwtebwAAACR0Uk5TAAMEBwgLDhozNkBXYGl5h4mYmqSpq7CyyMnR0tPg4efo7PP6mdzcJAAAAHNJREFUOMvt0McKgDAMgOG49151z/d/RtOeBKkBRbz4nwL5CLSwEcFXYG0ZY7UUdK4GmC4DuVjLwWDCNQiAADZfWlFZVhJgcFBcPFPnYKTAdBMsCaZyEOOQnUEPxxwKeBQIKZCewexjijiPQ/PGP/zgAdgBP6l0HLY8yu0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/Details/facebook.png
// module id = 736
// module chunks = 0